import axios from 'axios';

const apiBase = axios.create({
  baseURL: `${process.env.REACT_APP_INSV_API_BASE}`
});
apiBase.interceptors.request.use(async (config) => {
  const token = localStorage.tolkenINSV;
  
  if (token)
    config.headers.authorization = `${token}`;

  return config;
});

apiBase.interceptors.response.use(
  (response) => {
    return response;
  },
  
  (err) => Promise.reject(err)
);

export default apiBase